export function createEmptyVendor({ allowMultipleVendors, vendorTypeId = null } = {}) {
  return {
    vendorTypeId,
    vendor: null,
    isFacHappy: false,
    allowMultipleVendors: !!allowMultipleVendors,
    contractFiles: [],
    invoiceFiles: [],
  };
}
